import {HexColor} from "~/types/HexColor";

/**
 * Slugify a string
 * 
 * @param input The string to slugify.
 * @return The slugified string.
 */
export const slugify = (input: string) => {
    return input.toLowerCase().replace(/[^a-zA-Z0-9\w]/g, '-');
};

/**
 * Gets the most visible text color for a given background color.
 * This will be black for lighter colors and white for darker colors to ensure readability.
 * 
 * @param backgroundColor The background color to get the text color for. Must be a hex color.
 * @return The most visible text color for the given background color, either black or white. Defaults to black if the background color is not valid.
 */
export const getVisibleTextColor = (backgroundColor: HexColor) => {
    const isHexColor = /^#[0-9A-F]{6}$/i.test(backgroundColor);
    if (!isHexColor) {
        console.error("Invalid color, defaulting to black")
        return "#000000";
    }

    const red = parseInt(backgroundColor.substring(1, 3), 16);
    const green = parseInt(backgroundColor.substring(3, 5), 16);
    const blue = parseInt(backgroundColor.substring(5, 7), 16);
    
    const isLightColor = (red * 0.299 + green * 0.587 + blue * 0.114) > 186;
    return isLightColor
        ? "#000000"
        : "#FFFFFF";
}

/**
 * Find and replace a string with a substitute in a text.
 * 
 * @param text The text to search in.
 * @param find The string to find.
 * @param replace The string to replace the found string with.
 * @param replaceAll (Optional) Whether to replace all occurrences of the found string. Defaults to true.
 */
export const findAndReplace = (text: string, find: string, replace: string, replaceAll = true) => {
    const flags = replaceAll ? 'g' : '';
    const regex = new RegExp(find, flags);
    return text.replace(regex, replace);
}